import React from 'react'
import ReactDOM from 'react-dom'

import App from './app'

import Provider from './provider'

let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

ReactDOM.render(
  <React.StrictMode>
    <Provider>
      <App />
    </Provider>
  </React.StrictMode>,
  root,
)
